export type locationType = {
  address: string
  state: string
  city: string
  cep: string
  lat: string
  lng: string
  documentType?: string
  country?: string
}

export const ERRORS_LOCATION_STATE = {
  address: '',
  state: '',
  city: '',
  cep: '',
  lat: '',
  lng: '',
  country: ''
}

export const STATES = [
  { title: 'Acre', value: 'AC' },
  { title: 'Alagoas', value: 'AL' },
  { title: 'Amapá', value: 'AP' },
  { title: 'Amazonas', value: 'AM' },
  { title: 'Bahia', value: 'BA' },
  { title: 'Ceará', value: 'CE' },
  { title: 'Distrito Federal', value: 'DF' },
  { title: 'Espírito Santo', value: 'ES' },
  { title: 'Goiás', value: 'GO' },
  { title: 'Maranhão', value: 'MA' },
  { title: 'Mato Grosso do Sul', value: 'MS' },
  { title: 'Mato Grosso', value: 'MT' },
  { title: 'Minas Gerais', value: 'MG' },
  { title: 'Pará', value: 'PA' },
  { title: 'Paraíba', value: 'PB' },
  { title: 'Paraná', value: 'PR' },
  { title: 'Pernambuco', value: 'PE' },
  { title: 'Piauí', value: 'PI' },
  { title: 'Rio de Janeiro', value: 'RJ' },
  { title: 'Rio Grande do Norte', value: 'RN' },
  { title: 'Rio Grande do Sul', value: 'RS' },
  { title: 'Rondônia', value: 'RO' },
  { title: 'Roraima', value: 'RR' },
  { title: 'Santa Catarina', value: 'SC' },
  { title: 'São Paulo', value: 'SP' },
  { title: 'Sergipe', value: 'SE' },
  { title: 'Tocantins', value: 'TO' }
]
